<script>
  import { layoutMethods, customerListComputed} from "@/state/helpers";
  import cifModalLogs from "@/views/pages/profileInformation/cifModal/index.vue";

  /**
   * Profile Information component
   */
  export default {
    // props: {
    //   mainData: {
    //     type: Object
    //   }
    // },
    page: {
      title: "Profile Information"
    },
    components: {
      cifModalLogs
    },
    computed: {
      ...customerListComputed
    },
    data() {
      return {
        title: "Profile Information",
        infoType: null,
        isFulldetails: false
      };
    },
    methods: {
      ...layoutMethods,
      isEmpty (value) {
          return (
            // null or undefined
            (typeof value == "undefined") || 
            (value == undefined) ||
            (value == null) ||
            (value === "") ||
            // has length and it's zero
            // (value.hasOwnProperty('length') && value.length === 0) ||
            (Object.prototype.hasOwnProperty.call(value, length) && value.length === 0) ||
            // is an Object and has no keys
            (value.constructor === Object && Object.keys(value).length === 0)
          )
      },
      openModal(modal=''){
        this.$bvModal.show(modal);
      },
      closeModal(modal=''){
        this.$bvModal.hide(modal);
      },
    },
    async mounted(){
      this.infoType = this.$route.params.tab;
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <div class="card">
      <div class="card-body">
        <b-tabs
          content-class="p-3 text-muted"
          nav-class="nav-tabs-custom">
          <b-tab :active="infoType == 'Profile'"><!-- profile information -->
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">Profile Information</span>
            </template>

            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12"><!-- email address-->
                <p class="m-0 font-size-12">Email Address</p>
                <p class="font-size-15 text-dark">{{isEmpty(businessDetails.subscriberEmail) ? '--' : businessDetails.subscriberEmail}}</p>
              </div><!-- email address-->
              <div class="col-md-4 col-sm-6 col-xs-12"><!-- phone number -->
                <p class="m-0 font-size-12">Phone Number</p>
                <p class="font-size-15 text-dark">{{isEmpty(businessDetails.subscriberMobileNumber) ? '--' : businessDetails.subscriberMobileNumber}}</p>
              </div><!-- phone number -->
              <div class="col-md-4 col-sm-6 col-xs-12"><!-- DOB-->
                <p class="m-0 font-size-12">Date of Birth</p>
                <p class="font-size-15 text-dark">{{(isEmpty(businessDetails.subscriberDob) ? '--' : businessDetails.subscriberDob)  | formatDateOnly}}</p>
              </div><!-- DOB-->
              <div class="col-md-4 col-sm-6 col-xs-12"><!-- City of Birth-->
                <p class="m-0 font-size-12">City of Birth</p>
                <p class="font-size-15 text-dark">{{isEmpty(businessDetails.subscriberBirthplace) ? '--' : businessDetails.subscriberBirthplace}}</p>
              </div><!-- City of Birth-->
              <div class="col-md-4 col-sm-6 col-xs-12"><!-- country of birth-->
                <p class="m-0 font-size-12">Country of Birth (Nationality)</p>
                <p class="font-size-15 text-dark">{{isEmpty(businessDetails.subscriberNationality) ? '--' : businessDetails.subscriberNationality}}</p>
              </div><!-- country of birth-->
              <div class="col-md-12"><!-- Complete Home Address-->
                <p class="m-0 font-size-12">Complete Home Address</p>
                <p class="font-size-15 text-dark">{{isEmpty(businessDetails.subscriberAddress) ? '--' : businessDetails.subscriberAddress}}</p>
              </div><!-- Complete Home Address-->
            </div>
          </b-tab><!-- profile information -->

          <b-tab :active="infoType != 'Profile'"><!-- business information -->
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">Business Information</span>
            </template>

            <div class="row">
              <div class="col-sm-6 col-xs-12"><!-- Business Name-->
                <p class="m-0 font-size-12">Business Name</p>
                <p class="mb-3 font-size-15 text-dark text-capitalize">{{isEmpty(businessDetails.businessName) ? '--' : businessDetails.businessName}}</p>
                <p class="m-0 font-size-12">Business Number</p>
                <p class="mb-3 font-size-15 text-dark">{{isEmpty(businessDetails.businessMobileNumber) ? '--' : businessDetails.businessMobileNumber}}</p>
              </div><!-- Business Name-->
              <div class="col-sm-6 col-xs-12"><!-- business logo -->
                <img
                    :src="businessDetails.businessBusinessLogo"
                    alt=""
                    class="rounded"
                    width="100px"
                    @error="
                      (e) =>
                        (e.target.src = require('@/assets/images/img-placeholder.png'))
                    "
                />
              </div><!-- business logo -->
              <div class="col-sm-6 col-xs-12"><!-- Business Hours-->
                <p class="m-0 font-size-12">Business Hours</p>
                <p class="mb-3 font-size-15 text-dark">{{isEmpty(businessDetails.businessHours) ? '--' : businessDetails.businessHours}}</p>
              </div><!-- Business Hours-->
              <div class="col-sm-6 col-xs-12"><!-- Business Type-->
                <p class="m-0 font-size-12">Business Type</p>
                <p class="mb-3 font-size-15 text-dark">{{isEmpty(businessDetails.businessType) ? '--' : businessDetails.businessType}}</p>
              </div><!-- Business Type-->
              <div class="col-sm-12 col-xs-12"><!-- Business Address-->
                <p class="m-0 font-size-12">Business Address</p>
                <p class="mb-3 font-size-15 text-dark">{{isEmpty(businessDetails.businessLocation) ? '--' : businessDetails.businessLocation}}</p>
              </div><!-- Business Address-->
              <div class="col-sm-6 col-xs-12" v-if="isFulldetails"><!-- Source of Funds-->
                <p class="m-0 font-size-12">Source of Funds</p>
                <p class="mb-3 font-size-15 text-dark">?</p>
              </div><!-- Source of Funds-->
              <div class="col-sm-6 col-xs-12" v-if="isFulldetails"><!-- What industry is your business in-->
                <p class="m-0 font-size-12">What industry is your business in</p>
                <p class="mb-3 font-size-15 text-dark">{{isEmpty(businessDetails.businessSubType) ? '--' : businessDetails.businessSubType}}</p>
              </div><!-- What industry is your business in-->
              <div class="col-sm-6 col-xs-12" v-if="isFulldetails"><!-- Estimated Ave. Monthly Revenue-->
                <p class="m-0 font-size-12">Estimated Ave. Monthly Revenue</p>
                <p class="mb-3 font-size-15 text-dark">?</p>
              </div><!-- Estimated Ave. Monthly Revenue-->
              <div class="col-sm-6 col-xs-12" v-if="isFulldetails"><!-- Nature of Work-->
                <p class="m-0 font-size-12">Nature of Work</p>
                <p class="mb-3 font-size-15 text-dark">?</p>
              </div><!-- Nature of Work-->
              <div class="col-sm-6 col-xs-12" v-if="isFulldetails"><!-- How long have you been in business-->
                <p class="m-0 font-size-12">How long have you been in business</p>
                <p class="mb-3 font-size-15 text-dark">?</p>
              </div><!-- How long have you been in business-->
              <div class="col-sm-6 col-xs-12" v-if="isFulldetails"><!-- Do you have a physical store-->
                <p class="m-0 font-size-12">Do you have a physical store</p>
                <p class="mb-3 font-size-15 text-dark">?</p>
              </div><!-- Do you have a physical store-->
              <div class="col-sm-6 col-xs-12" v-if="isFulldetails"><!-- How many employees  do you have-->
                <p class="m-0 font-size-12">How many employees  do you have</p>
                <p class="mb-3 font-size-15 text-dark">?</p>
              </div><!-- How many employees  do you have-->
              <div class="col-sm-6 col-xs-12" v-if="isFulldetails"><!-- What are you selling-->
                <p class="m-0 font-size-12">What are you selling</p>
                <p class="mb-3 font-size-15 text-dark">?</p>
              </div><!-- What are you selling-->

            </div>
          </b-tab>
        </b-tabs><!-- business information -->
      </div>
      <b-card-footer>
        <span class="fw-semibold me-2">Change Log:</span>
        <b-link class="small fw-semibold" @click="openModal('bv-modal-cif-logs')">View</b-link>
      </b-card-footer>
    </div>


    <!-- MODAL -->
    <b-modal id="bv-modal-cif-logs" title="Reason Log" size="lg" 
             centered hide-header hide-title hide-footer hide-header-close no-close-on-backdrop>
      
      <cif-modal-logs/>
      
      <div class="text-end mt-3 mb-1">
        <b-button class="w-sm"
                  type="button"
                  variant="light"
                  @click="closeModal('bv-modal-cif-logs')"
                  >Close
        </b-button>
      </div>
    </b-modal><!--bv-modal-cif-logs-->
  </div> <!-- end of outer div-->
</template>